/* Apple DNA — S7 商品頁系列(pf-c4c30903 / pf-e04ac027)
   捲動浮現:與首頁 home-onex 同參數(IO threshold .12 / rootMargin -8% / 進場一次)。
   只針對下方圖片區,購買區不動;無 IO 或 reduced-motion 時不啟動(直接顯示)。
   對象:舊 PF deck 的 Image5(2台セット頁仍在用)+新 s7-deck 的圖與段落文字層
   (単台頁 2026-08-09 改版,見 snippets/s7-deck.liquid;.s7dk 位於 #__pf 內,
   既有 .s7-reveal CSS 範圍選擇器直接生效,毋須另加樣式)。
   流程:先加 s7-reveal 無過渡瞬間隱藏 → 雙 rAF 後加 s7-anim 啟用過渡 →
   捲入視窗加 s7-in 淡入。PageFly 生成檔不動,由 theme.liquid 條件式載入。 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* WO-1006-s7-2（2026-10-06）：脫 PageFly 新頁＝sections/ap-s7-deck 外殼 [data-s7-root]；PF 頁（2台・濾網）は従来の #__pf */
  var root = document.querySelector('[data-s7-root]') || document.querySelector('#__pf');
  if (!root) return;
  var els = Array.prototype.slice.call(
    root.querySelectorAll('[data-pf-type="Image5"], .s7dk__img, .s7dk .s7cl')
  );
  /* 特效6(2026-07-28):頁尾こちらもおすすめ卡加入同一套浮現(在 #__pf 外);
     2026-08-09 最終CTA(.s7cta,同在 #__pf 外)比照納入 */
  els = els.concat(Array.prototype.slice.call(document.querySelectorAll('.rp-card, .s7cta')));
  if (!els.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('s7-in');
        io.unobserve(e.target);
        /* 進場完卸掉過渡,rp-card 的 hover 上浮恢復 .3s 反應 */
        setTimeout(function () { e.target.classList.remove('s7-anim'); }, 900);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  els.forEach(function (el) {
    el.classList.add('s7-reveal');
    io.observe(el);
  });
  /* 隱藏態渲染完才啟用過渡(避免載入閃爍);rAF 被節流時 120ms 後備照樣啟用 */
  var armed = false;
  function arm() {
    if (armed) return;
    armed = true;
    els.forEach(function (el) { el.classList.add('s7-anim'); });
  }
  requestAnimationFrame(function () { requestAnimationFrame(arm); });
  setTimeout(arm, 120);
})();

/* 2026-09-01 Jack拍板:黏著購物車列(.s7-sticky)=退役——全商品頁=懸浮購物車
   (ap-cart-float)へ統一。本IIFEは主「注文する」のAJAX加車(C方案2026-07-28)
   +loading管理のみ存置:隱藏原生表單→product-form AJAX→抽屜auto-open,
   整頁/cart跳轉なし。復原=git本commit前版。 */
(function () {
  var atc = document.querySelector('[data-pf-type="ProductATC2"]');
  if (!atc) return;
  var hiddenSubmit = document.querySelector('[data-s7-submit]');
  var hiddenQty = document.querySelector('[data-s7-qty]');
  var pfQty = document.querySelector('[data-pf-type="QuantityField"]');
  var resetTimer;
  function setLoading(on) {
    atc.classList.toggle('s7-atc-loading', on);
  }
  function nativeAdd() {
    if (hiddenQty) {
      var q = pfQty ? parseInt(pfQty.value, 10) : 1;
      hiddenQty.value = q > 0 ? String(q) : '1';
    }
    setLoading(true);
    hiddenSubmit.click();
    clearTimeout(resetTimer);
    resetTimer = setTimeout(function () { setLoading(false); }, 5000);
  }
  atc.addEventListener('click', function (e) {
    if (!hiddenSubmit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (atc.classList.contains('s7-atc-loading')) return;
    nativeAdd();
  }, true);
  var drawerDialog = document.querySelector('.cart-drawer__dialog');
  if (drawerDialog && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawerDialog.hasAttribute('open')) {
        clearTimeout(resetTimer);
        setLoading(false);
      }
    }).observe(drawerDialog, { attributes: true, attributeFilter: ['open'] });
  }
})();
